export default "__VITE_ASSET__C8Zn8ywp__"